import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { PrivacyGuardPlugin, } from '@microsoft/1ds-privacy-guard-js';
import { App, makeBooleanDataField, makeDoubleDataField, makeInt64DataField, makeStringDataField, onNotification, Session, SuppressNexus, TelemetryLogger, User, } from '@microsoft/oteljs';
import { OneDSEndpoint, OneDSSink, OsPlugin, Sampler, } from '@microsoft/oteljs-1ds';
import { getDigest } from '@office-start/digest-utility';
import { encode } from '@office-start/encoding-utility';
import { logDebugCacheEvent } from '@office-start/instrumentation-service';
import { IDLE_LOW_PRIORITY, IMMEDIATE_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { APP_LANGUAGE, APP_STATE, APP_WORKLOAD, APP_WORKLOAD_TYPE, AUDIENCE_GROUP, BROWSER_SESSION_ID, DATA_BOUNDARY, DEPLOYMENT_ENV, DEVICE_ID, DEVICE_TYPE, DOMAIN_ORIGIN, ECS_RING, EVENT_SCHEMA_VERSION, FIRST_VISIT_AGE_IN_DAYS, FLIGHTS, FLIGHTS_HASH, INITIAL_PAGE_NAME, IS_ADMIN, IS_DYNAMICS, IS_EDU, IS_EDU_FACULTY, IS_EDU_STUDENT, IS_FIRST_VISIT, IS_IW, IS_SMB, NATIVE_APP_VERSION, NETWORK_TYPE, OS_VERSION, RELEASE, REQUEST_ORIGIN, SCHEMA_VERSION, SERVER_LOCATION, SERVICE_WORKER_STATE, USER_SEGMENT, WEB_TECH_TYPE, } from '@office-start/telemetry-types';
import { EventQueue, getFlattenedFieldName, isGuid, } from '@office-start/telemetry-utility';
import { addUnloadEvent } from '@office-start/unload-utility';
var desktopDeviceId;
var osVersion;
var nativeAppVersion;
var loggerEnabled = false;
var loggerInitialized = false;
var nameSpace = '';
var telemetryLogger;
var simpleOneDsSink;
var simpleTelemetryLogger;
var simpleLoggerEnabled = false;
var simpleLoggerInitialized = false;
var simpleEventQueue = new EventQueue();
var unAuthLoggerEnabled = false;
var unAuthLoggerInitialized = false;
var unAuthTelemetryLogger;
var unAuthOneDsSink;
var oneDsSink;
var persistentFields;
var eventQueue = new EventQueue();
var unAuthEventQueue = new EventQueue();
var oneDsSinkPromiseResolver;
export var authOneDsSinkPromise = new Promise(function (resolve) {
    oneDsSinkPromiseResolver = resolve;
});
var diagnosticNameSpace = '';
var diagnosticOneDsSink;
var diagnosticTelemetryLogger;
var releaseAudienceGroup = 'Automation';
/**
 * Function to delay-load OTELJS and initialize anonymous OTelTelemetry logger.
 *
 * TODO: Add tests, validation of event field and anonymous OTelTelemetry logger initialization
 *
 */
export function initializeUnAuthOTel(config) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            if (!(config.oTelEnabled && config.oTelAriaTenant) ||
                !isValidConfig(config.correlationId, config.sessionId) ||
                unAuthLoggerInitialized) {
                return [2 /*return*/, Promise.resolve()];
            }
            return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                unAuthLoggerEnabled = true;
                                nameSpace = config.oTelAriaNameSpace;
                                unAuthTelemetryLogger = new TelemetryLogger(undefined, undefined, {
                                    enableQueue: true,
                                });
                                unAuthTelemetryLogger.setTenantToken(config.oTelAriaNameSpace, config.oTelAriaTenant, SuppressNexus);
                                return [4 /*yield*/, getPartAFields(config.appName, config.appPlatform, config.appWorkload, config.bundleBuildDate, config.correlationId, config.deploymentEnvironment, config.deviceType, config.flights, config.isCorpNet, config.isTestTraffic, config.sessionId, config.serverLocation, config.requestOrigin, true, // isAnonymous
                                    undefined, undefined)];
                            case 1:
                                persistentFields = _a.sent();
                                // TODO: Add Privacy Guard to oneDsSink https://www.owiki.ms/wiki/Telemetry/Privacy/Privacy_Guard
                                if (config.win11DetectionEnabled) {
                                    getSinkOsPlugin().then(function (sinkOsPlugin) {
                                        unAuthOneDsSink = new OneDSSink(persistentFields, {
                                            endpointUrl: getOneDsEndpoint(config.deploymentEnvironment),
                                            plugins: [sinkOsPlugin],
                                        });
                                    });
                                }
                                else {
                                    unAuthOneDsSink = new OneDSSink(persistentFields, {
                                        endpointUrl: getOneDsEndpoint(config.deploymentEnvironment),
                                    });
                                }
                                unAuthTelemetryLogger.addSink(unAuthOneDsSink);
                                unAuthLoggerInitialized = true;
                                drainQueuedEvents(unAuthEventQueue, sendUnAuthEvent);
                                resolve();
                                return [2 /*return*/];
                        }
                    });
                }); })];
        });
    });
}
/**
 * Function to delay-load OTELJS without scheduling and initialize non-anonymous Simple OTelTelemetry logger.
 * This is used for bootstrapping error to flush the logs without full OtelConfig.
 *
 * TODO: Add tests, validation of event field and anonymous OTelTelemetry logger initialization
 *
 */
export function initializeSimpleOTelLogger(config) {
    var _this = this;
    if (!(config.oTelEnabled && config.oTelAriaTenant) ||
        !isValidConfig(config.correlationId, config.sessionId, config.identity.tenantId) ||
        simpleLoggerInitialized) {
        return Promise.resolve();
    }
    simpleLoggerEnabled = true;
    nameSpace = config.oTelAriaNameSpace;
    return setUpWindowsAppTelemetryFields(config.appPlatform, IMMEDIATE_PRIORITY)
        .then(function () { return __awaiter(_this, void 0, void 0, function () {
        var enablePG;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    simpleTelemetryLogger = new TelemetryLogger(undefined, undefined, {
                        enableQueue: config.win11DetectionEnabled,
                    });
                    simpleTelemetryLogger.setTenantToken(config.oTelAriaNameSpace, config.oTelAriaTenant, SuppressNexus);
                    return [4 /*yield*/, getPartAFields(config.appName, config.appPlatform, config.appWorkload, config.bundleBuildDate, config.correlationId, config.deploymentEnvironment, config.deviceType, config.flights, config.isCorpNet, config.isTestTraffic, config.sessionId, config.serverLocation, config.requestOrigin, false, // authenticated
                        config.identity, config.userSegment, config.ecsRing, config.appWorkloadType, config.networkType, config.serviceWorkerState, config.firstVisitAgeInDays, config.domainOrigin, config.initialPageName, config.dataBoundary, config.preferredCulture)];
                case 1:
                    persistentFields = _a.sent();
                    if (config.oTelDiagnosticAriaNameSpace &&
                        config.oTelDiagnosticAriaTenant) {
                        diagnosticNameSpace = config.oTelDiagnosticAriaNameSpace;
                        diagnosticTelemetryLogger = new TelemetryLogger(undefined, undefined, {
                            enableQueue: config.win11DetectionEnabled,
                        });
                        diagnosticTelemetryLogger.setTenantToken(config.oTelDiagnosticAriaNameSpace, config.oTelDiagnosticAriaTenant, SuppressNexus);
                    }
                    enablePG = enablePrivacyGuard();
                    // TODO: Add Privacy Guard to oneDsSink https://www.owiki.ms/wiki/Telemetry/Privacy/Privacy_Guard
                    if (config.win11DetectionEnabled) {
                        getSinkOsPlugin().then(function (sinkOsPlugin) {
                            simpleOneDsSink = new OneDSSink(persistentFields, {
                                endpointUrl: getOneDsEndpoint(config.deploymentEnvironment, config.dataBoundary, config.IsEudbEndpointEnabled),
                                plugins: enablePG
                                    ? [
                                        new PrivacyGuardPlugin(),
                                        sinkOsPlugin,
                                    ]
                                    : [sinkOsPlugin],
                                extensionConfig: enablePG
                                    ? {
                                        PrivacyGuardPlugin: getPrivacyGuardConfig(config.oTelAriaNameSpace, config.oTelAriaTenant),
                                    }
                                    : {},
                            });
                            setUpSampler(config.IsSamplingEnabled, config.identity.puid, config.correlationId);
                            simpleTelemetryLogger.addSink(simpleOneDsSink);
                            if (config.oTelDiagnosticAriaNameSpace &&
                                config.oTelDiagnosticAriaTenant) {
                                diagnosticOneDsSink = new OneDSSink(persistentFields, {
                                    endpointUrl: getOneDsEndpoint(config.deploymentEnvironment, config.dataBoundary, config.IsEudbEndpointEnabled),
                                    plugins: enablePG
                                        ? [
                                            new PrivacyGuardPlugin(),
                                        ]
                                        : [],
                                    extensionConfig: enablePG
                                        ? {
                                            PrivacyGuardPlugin: getPrivacyGuardConfig(config.oTelDiagnosticAriaNameSpace, config.oTelDiagnosticAriaTenant),
                                        }
                                        : {},
                                });
                                diagnosticTelemetryLogger.addSink(diagnosticOneDsSink);
                            }
                            simpleLoggerInitialized = true;
                            drainQueuedEvents(simpleEventQueue, sendSimpleLoggerEvent);
                        });
                    }
                    else {
                        simpleOneDsSink = new OneDSSink(persistentFields, {
                            endpointUrl: getOneDsEndpoint(config.deploymentEnvironment, config.dataBoundary, config.IsEudbEndpointEnabled),
                            plugins: enablePG
                                ? [new PrivacyGuardPlugin()]
                                : [],
                            extensionConfig: enablePG
                                ? {
                                    PrivacyGuardPlugin: getPrivacyGuardConfig(config.oTelAriaNameSpace, config.oTelAriaTenant),
                                }
                                : {},
                        });
                        setUpSampler(config.IsSamplingEnabled, config.identity.puid, config.correlationId);
                        simpleTelemetryLogger.addSink(simpleOneDsSink);
                        if (config.oTelDiagnosticAriaNameSpace &&
                            config.oTelDiagnosticAriaTenant) {
                            diagnosticOneDsSink = new OneDSSink(persistentFields, {
                                endpointUrl: getOneDsEndpoint(config.deploymentEnvironment, config.dataBoundary, config.IsEudbEndpointEnabled),
                                plugins: enablePG
                                    ? [new PrivacyGuardPlugin()]
                                    : [],
                                extensionConfig: enablePG
                                    ? {
                                        PrivacyGuardPlugin: getPrivacyGuardConfig(config.oTelDiagnosticAriaNameSpace, config.oTelDiagnosticAriaTenant),
                                    }
                                    : {},
                            });
                            diagnosticTelemetryLogger.addSink(diagnosticOneDsSink);
                        }
                        simpleLoggerInitialized = true;
                        drainQueuedEvents(simpleEventQueue, sendSimpleLoggerEvent);
                    }
                    return [2 /*return*/];
            }
        });
    }); })
        .catch(function () {
        // simpleTelemetryLogger initialization failed, set simpleLoggerEnabled to false to prevent buffering events to queue
        simpleLoggerEnabled = false;
    });
}
/**
 * Function to delay-load OTELJS and initialize non-anonymous OTelTelemetry logger.
 *
 * TODO: Add tests, validation of event field and anonymous OTelTelemetry logger initialization
 *
 */
export function initializeOTel(config) {
    var _this = this;
    if (!(config.oTelEnabled && config.oTelAriaTenant) ||
        !isValidConfig(config.correlationId, config.sessionId, config.identity.tenantId) ||
        loggerInitialized) {
        return Promise.resolve();
    }
    loggerEnabled = true;
    nameSpace = config.oTelAriaNameSpace;
    return setUpWindowsAppTelemetryFields(config.appPlatform, config.schedulerPriority)
        .then(function () { return __awaiter(_this, void 0, void 0, function () {
        var enablePG;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    telemetryLogger = new TelemetryLogger(undefined, undefined, {
                        enableQueue: config.win11DetectionEnabled,
                    });
                    telemetryLogger.setTenantToken(config.oTelAriaNameSpace, config.oTelAriaTenant, SuppressNexus);
                    return [4 /*yield*/, getPartAFields(config.appName, config.appPlatform, config.appWorkload, config.bundleBuildDate, config.correlationId, config.deploymentEnvironment, config.deviceType, config.flights, config.isCorpNet, config.isTestTraffic, config.sessionId, config.serverLocation, config.requestOrigin, false, // authenticated
                        config.identity, config.userSegment, config.ecsRing, config.appWorkloadType, config.networkType, config.serviceWorkerState, config.firstVisitAgeInDays, config.domainOrigin, config.initialPageName, config.dataBoundary, config.preferredCulture, config.deviceId, config.officeStartManifestVersion, config.webTechType, config.appState)];
                case 1:
                    persistentFields = _a.sent();
                    if (config.oTelDiagnosticAriaNameSpace &&
                        config.oTelDiagnosticAriaTenant) {
                        diagnosticNameSpace = config.oTelDiagnosticAriaNameSpace;
                        diagnosticTelemetryLogger = new TelemetryLogger(undefined, undefined, {
                            enableQueue: config.win11DetectionEnabled,
                        });
                        diagnosticTelemetryLogger.setTenantToken(config.oTelDiagnosticAriaNameSpace, config.oTelDiagnosticAriaTenant, SuppressNexus);
                    }
                    enablePG = enablePrivacyGuard();
                    if (config.win11DetectionEnabled) {
                        getSinkOsPlugin().then(function (sinkOsPlugin) {
                            oneDsSink = new OneDSSink(persistentFields, {
                                endpointUrl: getOneDsEndpoint(config.deploymentEnvironment, config.dataBoundary, config.IsEudbEndpointEnabled),
                                plugins: enablePG
                                    ? [
                                        new PrivacyGuardPlugin(),
                                        sinkOsPlugin,
                                    ]
                                    : [sinkOsPlugin],
                                extensionConfig: enablePG
                                    ? {
                                        PrivacyGuardPlugin: getPrivacyGuardConfig(config.oTelAriaNameSpace, config.oTelAriaTenant),
                                    }
                                    : {},
                            });
                            oneDsSinkPromiseResolver(oneDsSink);
                            setUpSampler(config.IsSamplingEnabled, config.identity.puid, config.correlationId);
                            telemetryLogger.addSink(oneDsSink);
                            if (config.oTelDiagnosticAriaNameSpace &&
                                config.oTelDiagnosticAriaTenant) {
                                diagnosticOneDsSink = new OneDSSink(persistentFields, {
                                    endpointUrl: getOneDsEndpoint(config.deploymentEnvironment, config.dataBoundary, config.IsEudbEndpointEnabled),
                                    plugins: enablePG
                                        ? [
                                            new PrivacyGuardPlugin(),
                                            sinkOsPlugin,
                                        ]
                                        : [sinkOsPlugin],
                                    extensionConfig: enablePG
                                        ? {
                                            PrivacyGuardPlugin: getPrivacyGuardConfig(config.oTelDiagnosticAriaNameSpace, config.oTelDiagnosticAriaTenant),
                                        }
                                        : {},
                                });
                                diagnosticTelemetryLogger.addSink(diagnosticOneDsSink);
                            }
                            loggerInitialized = true;
                            drainQueuedEvents(eventQueue, sendEvent);
                            addUnloadEvent(function () {
                                endSession(false);
                            }, true);
                        });
                    }
                    else {
                        oneDsSink = new OneDSSink(persistentFields, {
                            endpointUrl: getOneDsEndpoint(config.deploymentEnvironment, config.dataBoundary, config.IsEudbEndpointEnabled),
                            plugins: enablePG
                                ? [new PrivacyGuardPlugin()]
                                : [],
                            extensionConfig: enablePG
                                ? {
                                    PrivacyGuardPlugin: getPrivacyGuardConfig(config.oTelAriaNameSpace, config.oTelAriaTenant),
                                }
                                : {},
                        });
                        oneDsSinkPromiseResolver(oneDsSink);
                        setUpSampler(config.IsSamplingEnabled, config.identity.puid, config.correlationId);
                        telemetryLogger.addSink(oneDsSink);
                        if (config.oTelDiagnosticAriaNameSpace &&
                            config.oTelDiagnosticAriaTenant) {
                            diagnosticOneDsSink = new OneDSSink(persistentFields, {
                                endpointUrl: getOneDsEndpoint(config.deploymentEnvironment, config.dataBoundary, config.IsEudbEndpointEnabled),
                                plugins: enablePG
                                    ? [new PrivacyGuardPlugin()]
                                    : [],
                                extensionConfig: enablePG
                                    ? {
                                        PrivacyGuardPlugin: getPrivacyGuardConfig(config.oTelDiagnosticAriaNameSpace, config.oTelDiagnosticAriaTenant),
                                    }
                                    : {},
                            });
                            diagnosticTelemetryLogger.addSink(diagnosticOneDsSink);
                        }
                        loggerInitialized = true;
                        drainQueuedEvents(eventQueue, sendEvent);
                        addUnloadEvent(function () {
                            endSession(false);
                        }, true);
                    }
                    return [2 /*return*/];
            }
        });
    }); })
        .catch(function () {
        // logger initialization failed, set loggerEnabled to false to prevent buffering events to queue
        loggerEnabled = false;
    });
}
function listenToErrorNotification() {
    onNotification().addListener(function (event) {
        if (event.level === 0 /* LogLevel.Error */) {
            try {
                var params = {};
                params["Error" /* InstrumentationParam.Error */] = event.message();
                logDebugCacheEvent('OtelNotificationErrorEvent', params);
            }
            catch (e) {
                console.error(e);
            }
        }
    });
}
function setUpWindowsAppTelemetryFields(appPlatform, schedulerPriority) {
    if (appPlatform !== 'Universal') {
        return Promise.resolve();
    }
    return new Promise(function (resolve) {
        scheduleWork(function () {
            import('@office-start/hwa-native-bridge-service')
                .then(function (mod) { return mod.getWindowsAppTelemetryFields(); })
                .then(function (telemetryFields) {
                desktopDeviceId = telemetryFields.deviceId;
                osVersion = telemetryFields.osVersion;
                nativeAppVersion = telemetryFields.nativeAppVersion;
                resolve();
            })
                .catch(function (err) {
                console.log(err);
                resolve();
            });
        }, schedulerPriority !== null && schedulerPriority !== void 0 ? schedulerPriority : IDLE_LOW_PRIORITY);
    });
}
function getSinkOsPlugin() {
    return __awaiter(this, void 0, void 0, function () {
        var plugin;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    plugin = new OsPlugin();
                    return [4 /*yield*/, plugin.detectOs()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, plugin];
            }
        });
    });
}
function setUpSampler(isSamplingEnabled, userId, sessionId) {
    /*
     * Events with the event flag SamplingPolicy.Measure can be sampled, generally to help control telemetry costs.
     * In Office Online, events are sampled at 0.02 on User.PrimaryIdentityHash, with Session.Id as a fallback, using the djb2 algorithm. We recommend using the same setup as Office Online.
     */
    if (isSamplingEnabled) {
        var sampler = new Sampler();
        if (userId) {
            sampler.enableWithIdentifier('PrimaryIdentityHash', userId);
        }
        else {
            sampler.enableWithIdentifier('SessionId', sessionId);
        }
        var samplingRate = 0.02;
        sampler.setSampleRate(samplingRate);
        oneDsSink.addPreprocessor(sampler);
    }
}
/**
 * Function used to either send the event immediately when the simple telemetry logger is available
 * or buffer it until the simple telemetry logger is ready
 *
 * @param eventName Event name, used to construct fully qualified name
 * @param properties Additional data properties for event
 *
 */
export function sendSimpleLoggerEvent(eventName, properties, isSampled, isDiagnostic) {
    if (!simpleLoggerEnabled) {
        return;
    }
    if (simpleLoggerInitialized) {
        var fullyQualifiedName = isDiagnostic
            ? [diagnosticNameSpace, eventName].join('.')
            : [nameSpace, eventName].join('.');
        var dataFields = convertToDataFields(properties);
        sendTelemetryEvent(isDiagnostic ? diagnosticTelemetryLogger : simpleTelemetryLogger, fullyQualifiedName, dataFields, 2 /* DataCategories.ProductServiceUsage */, 110 /* DiagnosticLevel.RequiredServiceData */, isSampled ? 1 /* SamplingPolicy.Measure */ : 0 /* SamplingPolicy.NotSet */);
    }
    else {
        var event_1 = {
            eventName: eventName,
            params: properties,
            isSampled: isSampled,
        };
        simpleEventQueue.queueEvent(event_1);
    }
}
/**
 * Function used to either send the event immediately when the telemetry logger is available
 * or buffer it until the telemetry logger is ready
 *
 * @param eventName Event name, used to construct fully qualified name
 * @param properties Additional data properties for event
 *
 */
export function sendEvent(eventName, properties, isSampled, isDiagnostic) {
    sendEventCommon(eventName, properties, false, isSampled, isDiagnostic);
}
/**
 * Function used to either send the event immediately when the anonymous telemetry logger is available
 * or buffer it until the telemetry logger is ready
 *
 * @param eventName Event name, used to construct fully qualified name
 * @param properties Additional data properties for event
 *
 */
export function sendUnAuthEvent(eventName, properties, isSampled, isDiagnostic) {
    sendEventCommon(eventName, properties, true, isSampled, isDiagnostic);
}
function sendEventCommon(eventName, properties, isAnonymous, isSampled, isDiagnostic) {
    if (isAnonymous ? !unAuthLoggerEnabled : !loggerEnabled) {
        return;
    }
    if (isAnonymous ? unAuthLoggerInitialized : loggerInitialized) {
        // Event.Name: Office.Taos.Hub.<eventName> Event name follows a hierarchical name matching the tenant's name
        var fullyQualifiedName = isDiagnostic
            ? [diagnosticNameSpace, eventName].join('.')
            : [nameSpace, eventName].join('.');
        // Part C fields: Different for each event category
        //   - EventCategory
        //   - <EventCategory>Details (PageViewDetails.PageName, PageViewDetails.PageType, PageViewDetails.IsIntentional)
        var dataFields = convertToDataFields(properties);
        sendTelemetryEvent(isAnonymous
            ? unAuthTelemetryLogger
            : isDiagnostic
                ? diagnosticTelemetryLogger
                : telemetryLogger, fullyQualifiedName, dataFields, 2 /* DataCategories.ProductServiceUsage */, 110 /* DiagnosticLevel.RequiredServiceData */, isSampled ? 1 /* SamplingPolicy.Measure */ : 0 /* SamplingPolicy.NotSet */);
    }
    else {
        var event_2 = {
            eventName: eventName,
            params: properties,
            isSampled: isSampled,
            isDiagnostic: isDiagnostic,
        };
        isAnonymous
            ? unAuthEventQueue.queueEvent(event_2)
            : eventQueue.queueEvent(event_2);
    }
}
function sendTelemetryEvent(logger, eventName, dataFields, dataCategories, diagnosticLevel, samplingPolicy) {
    logger.sendTelemetryEvent({
        eventName: eventName,
        dataFields: dataFields,
        eventFlags: {
            dataCategories: dataCategories,
            diagnosticLevel: diagnosticLevel,
            samplingPolicy: samplingPolicy,
        },
    });
}
/**
 *  Function to generate telemetry fields to be sent on every event.
 *  Part A fields: common fields, these fields should be set on the 1DS sink and cannot be changed
 *    - Required Part A: Fields are required for events that can be processed in COSMOS (App, Session and User)
 *         - App (App.Platform, App.Name)
 *         - Session (Session.Id): use correlationId as primary id
 *         - User (User.IsAnonymous, User.PrimaryIdentityHash, User.PrimaryIdentitySpace, User.TenantGroup, User.TenantId)
 *         - Release (Release.AudienceGroup)
 *    - Customize Part A:
 *         - EventSchemaVersion
 *         - RequestOrigin
 *         - SessionId
 *         - UserSegment (UserSegment.IsAdmin, UserSegment.IsDynamics, UserSegment.IsEdu, UserSegment.IsEduFaculty, UserSegment.IsEduStudent, UserSegment.IsFirstVisit, UserSegment.IsIw, UserSegment.IsSmb)
 */
export function getPartAFields(appName, appPlatform, appWorkload, bundleBuildDate, correlationId, deploymentEnvironment, deviceType, flights, isCorpNet, isTestTraffic, sessionId, serverLocation, requestOrigin, isAnonymous, identity, userSegment, ecsRing, appWorkloadType, networkType, serviceWorkerState, firstVisitAgeInDays, domainOrigin, initialPageName, dataBoundary, preferredCulture, deviceId, officeStartManifestVersion, webTechType, appState) {
    return __awaiter(this, void 0, void 0, function () {
        var VERSION, buildDate, appVersion, requiredPartADataFields, puid, idSpace, customPartADataFields, flightsHash, partADataFields;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    VERSION = '0';
                    buildDate = bundleBuildDate.split(' ')[0].split('-').join('');
                    appVersion = [buildDate, VERSION].join('.');
                    if (officeStartManifestVersion) {
                        appVersion = appVersion + '.' + officeStartManifestVersion;
                    }
                    releaseAudienceGroup = getReleaseAudienceGroup(deploymentEnvironment, isCorpNet, isTestTraffic);
                    requiredPartADataFields = __spreadArray(__spreadArray(__spreadArray([], __read(App.getFields({
                        platform: appPlatform,
                        name: appName,
                        version: appVersion,
                    })), false), __read(Session.getFields({
                        id: correlationId,
                    })), false), [
                        makeStringDataField(getFlattenedFieldName([RELEASE, AUDIENCE_GROUP]), releaseAudienceGroup),
                        makeStringDataField(DEPLOYMENT_ENV, deploymentEnvironment),
                    ], false);
                    if (isAnonymous) {
                        requiredPartADataFields.push.apply(requiredPartADataFields, __spreadArray([], __read(User.getFields({
                            isAnonymous: true,
                        })), false));
                    }
                    else {
                        puid = identity === null || identity === void 0 ? void 0 : identity.puid;
                        idSpace = '';
                        if (puid) {
                            idSpace = (identity === null || identity === void 0 ? void 0 : identity.isMsa) ? 'MsaPuid' : 'OrgIdPuid';
                        }
                        requiredPartADataFields.push.apply(requiredPartADataFields, __spreadArray([], __read(User.getFields({
                            primaryIdentityHash: puid,
                            primaryIdentitySpace: idSpace,
                            tenantId: identity === null || identity === void 0 ? void 0 : identity.tenantId,
                            tenantGroup: (identity === null || identity === void 0 ? void 0 : identity.isMsa) ? 'Consumer' : 'Commercial',
                            isAnonymous: false,
                        })), false));
                    }
                    customPartADataFields = [
                        makeStringDataField(EVENT_SCHEMA_VERSION, SCHEMA_VERSION),
                        makeStringDataField(REQUEST_ORIGIN, requestOrigin),
                        makeStringDataField(BROWSER_SESSION_ID, sessionId),
                        makeStringDataField(APP_WORKLOAD, appWorkload),
                        makeStringDataField(SERVER_LOCATION, serverLocation),
                        makeStringDataField(DEVICE_TYPE, deviceType),
                        makeStringDataField(WEB_TECH_TYPE, webTechType !== null && webTechType !== void 0 ? webTechType : ''),
                        makeStringDataField(APP_STATE, appState !== null && appState !== void 0 ? appState : ''),
                    ];
                    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isAdmin) {
                        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_ADMIN]), userSegment.isAdmin));
                    }
                    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isDynamics) {
                        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_DYNAMICS]), userSegment.isDynamics));
                    }
                    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isEdu) {
                        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_EDU]), userSegment.isEdu));
                    }
                    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isEduFaculty) {
                        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_EDU_FACULTY]), userSegment.isEduFaculty));
                    }
                    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isEduStudent) {
                        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_EDU_STUDENT]), userSegment.isEduStudent));
                    }
                    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isFirstVisit) {
                        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_FIRST_VISIT]), userSegment.isFirstVisit));
                    }
                    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isIw) {
                        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_IW]), userSegment.isIw));
                    }
                    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isSmb) {
                        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_SMB]), userSegment.isSmb));
                    }
                    if (!flights) return [3 /*break*/, 2];
                    customPartADataFields.push(makeStringDataField(FLIGHTS, flights));
                    return [4 /*yield*/, getDigest(crypto.subtle, flights, '', // Salt: Salt is not needed due to flight hash is not used in any security context.
                        function (toEncode) { return encode(toEncode); })];
                case 1:
                    flightsHash = _a.sent();
                    customPartADataFields.push(makeStringDataField(FLIGHTS_HASH, flightsHash));
                    _a.label = 2;
                case 2:
                    if (appWorkloadType) {
                        customPartADataFields.push(makeStringDataField(APP_WORKLOAD_TYPE, appWorkloadType));
                    }
                    if (ecsRing) {
                        customPartADataFields.push(makeStringDataField(ECS_RING, ecsRing));
                    }
                    if (networkType) {
                        customPartADataFields.push(makeStringDataField(NETWORK_TYPE, networkType));
                    }
                    if (serviceWorkerState) {
                        customPartADataFields.push(makeStringDataField(SERVICE_WORKER_STATE, serviceWorkerState));
                    }
                    if (firstVisitAgeInDays) {
                        customPartADataFields.push(makeInt64DataField(FIRST_VISIT_AGE_IN_DAYS, firstVisitAgeInDays));
                    }
                    if (domainOrigin) {
                        customPartADataFields.push(makeStringDataField(DOMAIN_ORIGIN, domainOrigin));
                    }
                    if (initialPageName) {
                        customPartADataFields.push(makeStringDataField(INITIAL_PAGE_NAME, initialPageName));
                    }
                    if (dataBoundary) {
                        customPartADataFields.push(makeStringDataField(DATA_BOUNDARY, dataBoundary));
                    }
                    if (preferredCulture) {
                        customPartADataFields.push(
                        // We use preferredCulture to determine what language to display our app in
                        // preferredCulture: user's preferred language, which is set on the user's account settings page. If no language is set, then we use the browser's language
                        makeStringDataField(APP_LANGUAGE, preferredCulture));
                    }
                    if (appPlatform === 'Universal') {
                        customPartADataFields.push(makeStringDataField(DEVICE_ID, desktopDeviceId !== null && desktopDeviceId !== void 0 ? desktopDeviceId : ''), makeStringDataField(OS_VERSION, osVersion !== null && osVersion !== void 0 ? osVersion : ''), makeStringDataField(NATIVE_APP_VERSION, nativeAppVersion !== null && nativeAppVersion !== void 0 ? nativeAppVersion : ''));
                    }
                    partADataFields = __spreadArray(__spreadArray([], __read(requiredPartADataFields), false), __read(customPartADataFields), false);
                    return [2 /*return*/, partADataFields];
            }
        });
    });
}
export function getOneDsEndpoint(deploymentEnvironment, dataBoundary, IsEudbEndpointEnabled) {
    if (dataBoundary === 'EU' && IsEudbEndpointEnabled) {
        return OneDSEndpoint.EUDB;
    }
    switch (deploymentEnvironment) {
        case "pfprodprv" /* OfficeEnvironment.PFProdPrv */:
        case "pfprod" /* OfficeEnvironment.PFProd */:
            return OneDSEndpoint.USGOV_DOD;
        case "tbprodprv" /* OfficeEnvironment.TBProdPrv */:
        case "tbprod" /* OfficeEnvironment.TBProd */:
            return OneDSEndpoint.USGOV_DOJ;
        default:
            return OneDSEndpoint.PUBLIC;
    }
}
export function getReleaseAudienceGroup(deploymentEnvironment, isCorpNet, isTestTraffic) {
    if (isTestTraffic) {
        return 'Automation';
    }
    switch (deploymentEnvironment) {
        case "dev" /* OfficeEnvironment.Dev */:
        case "ppe" /* OfficeEnvironment.PPE */:
        case "prodprv" /* OfficeEnvironment.ProdPrv */:
            return 'Automation';
        case "prod" /* OfficeEnvironment.Prod */:
        case "bfprod" /* OfficeEnvironment.BFProd */:
        case "pfprod" /* OfficeEnvironment.PFProd */:
        case "tbprod" /* OfficeEnvironment.TBProd */:
        case "unprod" /* OfficeEnvironment.UNProd */:
        case "usprod" /* OfficeEnvironment.USProd */:
            if (isCorpNet) {
                return 'Microsoft';
            }
            return 'Production';
        default:
            return 'Automation';
    }
}
// Function to flush the queue
function drainQueuedEvents(queue, sendEventCallback) {
    var queuedEvents = queue.drainQueue();
    queuedEvents.forEach(function (event) {
        if (event.eventName) {
            sendEventCallback(event.eventName, event.params || {}, event.isSampled, event.isDiagnostic);
        }
    });
}
/**
 * Helper function to help convert the defined telemetry fields to the OTEL DataFields.
 *
 * @param data - Additional properties for event
 */
function convertToDataFields(data) {
    return Object.keys(data)
        .filter(function (key) {
        return typeof data[key] == 'number' ||
            typeof data[key] == 'boolean' ||
            typeof data[key] == 'string';
    })
        .map(function (key) {
        var value = data[key];
        if (typeof value === 'boolean') {
            return makeBooleanDataField(key, value);
        }
        else if (typeof value === 'number') {
            if (Number.isInteger(value)) {
                return makeInt64DataField(key, value);
            }
            else {
                return makeDoubleDataField(key, value);
            }
        }
        return makeStringDataField(key, value);
    });
}
function enablePrivacyGuard() {
    switch (releaseAudienceGroup) {
        case 'Automation':
            return true;
        case 'Microsoft':
        case 'Production':
            return false;
        default:
            return false;
    }
}
export function isValidConfig(correlationId, sessionId, tenantId) {
    return (isGuid(correlationId) &&
        isGuid(sessionId) &&
        (!tenantId || isGuid(tenantId)));
}
export function endSession(isAnonymous) {
    if (isAnonymous
        ? !(unAuthLoggerEnabled && unAuthLoggerInitialized)
        : !(loggerEnabled && loggerInitialized)) {
        return;
    }
    drainQueuedEvents(isAnonymous ? unAuthEventQueue : eventQueue, isAnonymous ? sendUnAuthEvent : sendEvent);
    try {
        var logger = isAnonymous ? unAuthTelemetryLogger : telemetryLogger;
        logger.telemetrySinks.forEach(function (sink) {
            var _a, _b;
            (_b = (_a = sink).flush) === null || _b === void 0 ? void 0 : _b.call(_a, false);
        });
    }
    catch (e) {
        console.log(e);
    }
}
export function getPrivacyGuardConfig(tenantNameSpace, tenantID) {
    return {
        notificationEventName: tenantNameSpace + '.PrivacyConcern',
        iKey: tenantID,
        scanForUrls: false, //Should scan for URLs such as `microsoft.com`, `dropbox.com`, etc
    };
}
//# sourceMappingURL=OtelTelemetryService.js.map